// Докрутка: карточки товара растут, пока грузятся картинки и инициализируются
// слайдеры, поэтому после перехода по якорю позицию приходится выравнивать
// ещё несколько раз, пока раскладка не устоится.
const EVENING_SETTLE_DELAYS = [350, 900, 1600];

class EveningNavigator extends HTMLElement {
  connectedCallback() {
    this.nav = this.querySelector('.evening-navigator__nav');
    this.chips = Array.from(this.querySelectorAll('[data-chip-for]'));
    // Чип может вести и в соседнюю секцию (рецепты, метраж, цвета),
    // поэтому цели ищем по всему документу, а не внутри себя.
    this.targets = this.chips
      .map((chip) => document.getElementById(chip.dataset.chipFor))
      .filter(Boolean);

    if (!this.chips.length || !this.targets.length) return;

    this.section = this.closest('.evening-navigator') || this;
    // Чипы расставляет редактор, их порядок не обязан совпадать с порядком на
    // странице — для нижней границы показа нужна последняя цель по документу.
    this.ordered = this.targets
      .slice()
      .sort((a, b) =>
        a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      );
    this.lastTarget = this.ordered[this.ordered.length - 1];
    this.onClick = this.onClick.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.measure = this.measure.bind(this);

    this.addEventListener('click', this.onClick);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.measure, { passive: true });

    this.measure();
    this.onScroll();

    const hash = window.location.hash.slice(1);
    if (hash) {
      const target = document.getElementById(hash);
      if (target && this.targets.indexOf(target) !== -1) this.scrollToBlock(target);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.measure);
    this.clearSettle();
  }

  // Высота панели уезжает в CSS-переменную: от неё считается scroll-margin
  // у всех целей, иначе панель накрывает заголовок раздела.
  measure() {
    if (!this.nav) return;
    const height = this.nav.offsetHeight;
    if (height) {
      document.documentElement.style.setProperty('--evening-nav-h', height + 'px');
    }
  }

  onScroll() {
    if (this.frame) return;
    this.frame = window.requestAnimationFrame(() => {
      this.frame = null;
      if (!this.nav) return;
      const start = this.section.getBoundingClientRect().top;
      const end = this.lastTarget.getBoundingClientRect().bottom;
      const inRange = start < 0 && end > 0;
      this.nav.classList.toggle('is-visible', inRange);
      this.syncActive();
    });
  }

  onClick(event) {
    const chip = event.target.closest('[data-chip-for]');
    if (!chip || !this.contains(chip)) return;

    const target = document.getElementById(chip.dataset.chipFor);
    if (!target) return;

    event.preventDefault();
    this.setActive(target.id);
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + chip.dataset.chipFor);
    }
    this.scrollToBlock(target);
  }

  scrollToBlock(target) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

    this.clearSettle();
    this.settleTimers = EVENING_SETTLE_DELAYS.map((delay) =>
      setTimeout(() => {
        const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        if (Math.abs(target.getBoundingClientRect().top - offset) > 8) {
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }, delay)
    );
  }

  clearSettle() {
    (this.settleTimers || []).forEach(clearTimeout);
    this.settleTimers = [];
  }

  // Подсветка по позиции прокрутки, а не по пересечению: наблюдатель брал
  // первый блок, попавший в полосу, и после перехода на «Цвета» подсвечивал
  // следующий за ними блок.
  syncActive() {
    let current = this.ordered[0];
    this.ordered.forEach((target) => {
      const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      if (target.getBoundingClientRect().top - offset <= 8) current = target;
    });
    if (current) this.setActive(current.id);
  }

  setActive(id) {
    this.chips.forEach((chip) => {
      if (chip.dataset.chipFor === id) {
        chip.setAttribute('aria-current', 'true');
      } else {
        chip.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('evening-navigator')) {
  customElements.define('evening-navigator', EveningNavigator);
}
